import { render, staticRenderFns } from "./SetInitBuyerYearInvoice.vue?vue&type=template&id=5df662b4&scoped=true&"
import script from "./SetInitBuyerYearInvoice.vue?vue&type=script&lang=js&"
export * from "./SetInitBuyerYearInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df662b4",
  null
  
)

export default component.exports